import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import ProzessSidebarModalWrapper from '@/@core/components/ProzessSidebarModalWrapper.vue'
import ProzessPagination from '@/@core/components/ProzessPagination.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('ProzessPagination', ProzessPagination)
Vue.component('ProzessSidebarModalWrapper', ProzessSidebarModalWrapper)
